import { documentReady, gebi, getOffset, getUrlVars, isMobileView, isValidEmail, l, loadJavascript, lreplace, qs, setUrlParameter, slideDown, slideUp, urlParameterDelete } from '@utils/toolbox';
import { ConnectApi } from '@js/plugins/connectApi';
import '@sass/information/information.scss';
import { cookieNotice } from '@js/plugins/splitTestCookie';
import { toaster } from '@js/components/toast';


const informationDesktop = {
	isMobile: isMobileView(),
	currView: null,
	currNavTab: null,

	async init () {
		// Set initial view from URL parameter
		const view = getUrlVars(window.location.search).view;
		if (view) {
			this.currView = view;
			if (this.currView == 'emission') {
				this.currNavTab = 'emission';
			}
			if (this.currView) {
				document.querySelector(`.abHeader__dropdownItem[data-val='${this.currView}']`)?.classList.add('abHeader__dropdownItem--active');
			}
		}
		await this.setView();
		this.events();
		const sectionName = getUrlVars(window.location.search)?.section;
		if (window.location.search && sectionName) {
			this.scrollToSection(sectionName);
		}

		this.addManageConsentButton();
	},

	addManageConsentButton () {
		// privacyPolicy
		const element = qs('#privacyPolicy .infoTabs__main');
		if (!element) {
			return;
		}

		// Insert h4 at the bottom
		const h4 = document.createElement('h4');
		h4.innerText = l('information.privacyManager.title');
		h4.classList.add('infoTabs__manage-consent');
		element.appendChild(h4);

		// Add div with class
		const div = document.createElement('div');
		div.classList.add('flex', 'items-center', 'justify-center', 'infoTabs__manage-consent-button');
		// Add button inside div
		const button = document.createElement('button');
		button.innerText = l('information.privacyManager.button');
		button.classList.add('abBtn', 'abBtn--blueWhite');
		button.addEventListener('click', cookieNotice.showManageModal.bind(cookieNotice));

		div.appendChild(button);
		element.appendChild(div);
	},

	async loadRecaptcha () {
		// If after 10 seconds we didn’t get consent inform the user that they need to disable adblocker to use the form
		setTimeout(() => {
			if (!this.isRecaptchaLoaded) {
				// Inform in swedish
				toaster.newToast('För att kunna skicka in formuläret behöver du stänga av din adblockerare.', 'error', 'top');
			}
		}, 5000);

		// This is a "best effort" attempt to get consent for local storage, but if the user has an adblocker, we can't do anything about it.
		const consentResponse = await cookieNotice.requestLocalStorageConsent();

		if (this.isRecaptchaLoaded || !consentResponse) {
			return;
		}

		this.isRecaptchaLoaded = true;

		window.recaptchOnLoad = () => {
			grecaptcha.render('RecaptchaField2', {
				sitekey: '6LfO-6cZAAAAACxE5FfMt_nn99Zmlsgy8H7Vnzvy',
				callback: this.missingAirportRecaptchaCallback
			});
		};

		loadJavascript({ src: js_params.recaptchaUrl }, { async: '', defer: '', id: 'recaptcha-script' });
	},

	scrollToSection (sectionName) {
		const section = gebi(sectionName);
		const { top } = getOffset(section);
		window.scrollTo({ top, behavior: 'smooth' });
	},

	// Toggle state and control appearance of header sub section
	toggleTab () {
		const tabs = document.querySelectorAll('.infoTabs__tab');

		if (this.isMobile) {
			for (let i = 0; i < tabs.length; i++) {
				const tab = tabs[i];
				const main = tab.getElementsByClassName('infoTabs__main')[0];

				tab.style.display = 'block';

				if (this.currView === tab.id) {
					slideDown(main);
				} else {
					slideUp(main);
				}
			}
		} else {
			for (let i = 0; i < tabs.length; i++) {
				const tab = tabs[i];

				if (i === 0 && this.currView === null) {
					tab.style.display = 'block';
				} else {
					tab.style.display = (this.currView === tab.id) ? 'block' : 'none';
				}
			}
		}
	},

	// Toggle state and control appearance of lateral tabs
	toggleTabBtns () {
		const infoBtns = document.getElementById('infoTabBtns');
		const btns = infoBtns.children;

		for (let i = 0; i < btns.length; i++) {
			const btn = btns[i];

			if (i === 0 && this.currView === null) {
				btn.classList.add('active');
			} else if (btn.dataset.val === this.currView) {
				btn.classList.add('active');
			} else {
				btn.classList.remove('active');
			}
		}
	},

	// Show FAQ lateral navigation (only available for tablet and desktop)
	toggleFAQ () {
		const links = document.getElementById('qna-links');
		const showLinks = this.currView === 'faq';

		links.style.display = (showLinks) ? 'block' : 'none';
	},

	missingAirportRecaptchaCallback (event) {
		if (event) {
			document.querySelector('#missing-airport-submit').classList.remove('card__btn--disabled');
		}
	},

	contactFormRecaptchaCallback (event) {
		if (event) {
			document.querySelector('#contact-form-submit').disabled = false;
		}
	},

	// Toggle navigation tabs being shortcuts for information page (set as climatechange active for instance)
	toggleNavTabBtns () {
		const emissionTab = document.querySelector('.abHeader__item--emission .abHeader__link');

		if (!emissionTab) {
			return;
		}

		const infoTab = document.querySelector('.abHeader__item--information .abHeader__link');
		if (this.currNavTab === 'emission' && this.currView === 'emission') {
			emissionTab.classList.add('abHeader__link--active');
			infoTab.classList.remove('abHeader__link--active');
		} else {
			emissionTab.classList.remove('abHeader__link--active');
			infoTab.classList.add('abHeader__link--active');
		}
	},

	async setView (viewID) {
		this.currView = viewID || this.currView;

		if (this.currView) {
			const url = new URL(window.location.href);
			url.searchParams.set('view', this.currView);
			window.history.replaceState({}, '', url.pathname + url.search + url.hash);
		}

		// Clear out url section parameter if we're not on the faq tab
		if (this.currView !== 'faq') {
			urlParameterDelete('section');
		}

		this.toggleFAQ();
		this.toggleTab();
		this.toggleTabBtns();
		this.toggleNavTabBtns();

		if (this.currView === 'missingAirport') {
			await this.loadRecaptcha();
		}
	},

	events () {
		window.addEventListener('resize', (event) => {
			this.isMobile = isMobileView();
			this.setView();
		}, false);

		document.querySelector('#contact-ota-select').addEventListener('change', ({ target }) => {
			if (target.value === 'default') {
				return;
			}


			// // // Get data
			// const ota = js_params.otaContactInfo.find(ota => ota.id === target.value);
			// const { contact_email, contact_domain, contact_phone } = ota;

			// // Email
			// const email = document.querySelector('#contact_email');
			// const emailValue = email.querySelector('.contact-value');
			// const emailAnchor = email.querySelector('a');

			// console.log(!!contact_email)
			// email.classList.toggle('hidden', contact_email);
			// emailAnchor.href = 'mailto:' + contact_email;
			// emailValue.innerText = contact_email;

			// // Domain
			// const domain = document.querySelector('#contact_domain');
			// const domainValue = domain.querySelector('.contact-value');
			// const domainAnchor = domain.querySelector('a');

			// domain.classList.toggle('hidden', !!contact_domain);
			// domainAnchor.href = contact_domain;
			// domainValue.innerText = contact_domain;

			// // Phone
			// const phone = document.querySelector('#contact_email');
			// const phoneValue = phone.querySelector('.contact-value');
			// const phoneAnchor = phone.querySelector('a');

			// phone.classList.toggle('hidden', !!contact_phone);
			// phoneAnchor.href = 'tel:' + contact_phone;
			// phoneValue.innerText = contact_phone;

			const ota = js_params.otaContactInfo.find(ota => ota.id === parseInt(target.value));


			document.querySelector('#contact-ota-info').classList.remove('hidden');

			// List elements and object keys
			['contact_email', 'contact_domain', 'contact_phone'].forEach((field) => {
				const element = document.querySelector(`#${field}`);
				element.classList.toggle('hidden', !ota[field]);
				element.classList.toggle('divider', false);
				element.classList.toggle('last', false);

				let contactValueString = ota[field];
				if (field === 'contact_phone') {
					const matches = ota[field].match(/^\+(\d{2})(\d{2})(\d{3})(\d{2})(\d+)?$/);
					if (matches?.length === 6) {
						contactValueString = '+' + matches[1] + ' ' + matches[2] + ' ' + matches[3] + ' ' + (matches[4] ?? '') + ' ' + (matches[5] ?? '');
					}
				} else if (ota[field]) {
					contactValueString = ota[field].replace(/(https:\/\/)*(www\.)*/, '');
				}
				element.querySelector('.contact-value').innerHTML = contactValueString;

				const anchor = element.querySelector('a');
				switch (field) {
					case 'contact_email':
						anchor.href = 'mailto:' + ota[field];
						break;
					case 'contact_domain':
						anchor.href = ota[field];
						break;
					case 'contact_phone':
						anchor.href = 'tel:' + ota[field];
						break;
				}
			});

			// Update dividers
			const contactOtaBoxes = document.querySelectorAll('.contact-ota-info-box:not(.hidden)');
			contactOtaBoxes.forEach((contactOtaBox, index) => {
				if (index === contactOtaBoxes.length - 1) {
					contactOtaBox.classList.add('last');
				} else {
					contactOtaBox.classList.add('info-divider');
				}
			});
		});

		document.addEventListener('click', async (event) => {
			const clicked = event.target;

			// handle info sub section header mobile only
			if (clicked.matches('.infoTabs__top')) {
				if (!this.isMobile) {
					return;
				}

				const viewID = clicked.parentNode.id;

				if (viewID === this.currView) {
					this.currView = null;
					this.setView();
				} else {
					this.setView(viewID);
				}

				return;
			}
			// handle info tab click (lateral list)
			if (
				(clicked.closest('.abHeader__dropdownItem') && clicked.closest('.abHeader__dropdownItem').dataset?.val)
				|| (clicked.matches('.tab-btn') && clicked.dataset?.val)
				|| (clicked.matches('#faq a') && !!clicked.dataset?.val)) {
				if (clicked.closest('.abHeader__dropdownItem')) {
					document.querySelector('.abHeader__dropdownItem--active')?.classList.remove('abHeader__dropdownItem--active');
					clicked.closest('.abHeader__dropdownItem').classList.add('abHeader__dropdownItem--active');
				}
				const value = clicked.closest('.abHeader__dropdownItem')?.dataset?.val || clicked?.dataset?.val;
				event.preventDefault();
				this.setView(value);

				return;
			}
			// Scroll to clicked FAQ sub section
			if (clicked.matches('#qna-links a')) {
				event.preventDefault();

				const sectionName = getUrlVars(event.target.href).section;
				const newUrl = setUrlParameter(window.location.href, 'section', sectionName);

				window.history.replaceState({}, '', newUrl);

				this.scrollToSection(sectionName);
				return;
			}

			// Toggle navigation tab active state and view
			if (clicked.matches('.abHeader__item--emission .abHeader__link')) {
				event.preventDefault();

				this.currNavTab = 'emission';
				this.setView(this.currNavTab);

				return;
			}

			if (clicked.matches('#missing-airport-submit')) {
				await this.loadRecaptcha();


				const iata = document.getElementById('input-missing-airport-iata').value;
				const name = document.getElementById('input-missing-airport-name').value;
				const recaptchaResponse = grecaptcha.getResponse(0);
				if (!iata && !name) {
					alert(l('error.e9'));
					return;
				}
				if (!recaptchaResponse) {
					alert(l('global.simplePhrases.ClickImNotRobot'));
				}
				if ((iata || name) && recaptchaResponse) {
					document.querySelector('#missing-airport-submit').disabled = true; // functionally disabled
					document.querySelector('#missing-airport-submit').classList.add('card__btn--disabled'); // visually disabled

					ConnectApi('UserReport', 'reportMissingAirport', [iata, name, recaptchaResponse]).then((resp) => {
						grecaptcha.reset(0);
						const container = document.querySelector('#missing-airport .card');
						if (resp) {
							container.innerHTML = `<h3 class="card__title"><img src="/static/v${js_params.version}/images/global/checkmark-green.png" height="24px" alt="checkmark" ><div>${l('infopage.reportMissingAirports.success')}</div></h3><p></p>`;
						} else {
							container.innerHTML = `<h3 class="card__title">${lreplace('error.e12', { email: 'info@flygresor.se' })}</h3><p></p>`;
						}
					});
				}
			}
		}, false);

		// Handle contact form event (verification + submission)
		document.addEventListener('submit', (event) => {
			const submitted = event.target;

			if (submitted.matches('#contact-form')) {
				const email = document.getElementById('form-email-address').value;
				const message = document.getElementById('form-message').value;

				if (!isValidEmail(email)) {
					event.preventDefault();
					window.alert(l('email_error.invalidAdress'));
				} else if (message.trim() === '') {
					event.preventDefault();
					window.alert('Please enter a message.');
				}
			}
		}, false);
	}
};


documentReady(async () => {
	window.informationDesktop = informationDesktop;
	informationDesktop.init();
});
